import * as React from "react";
import moment from "moment";
import { getVerificationResult } from "../../services/verificationService";

export const FacesheetVerification = ({ verifications }) => {
    return (
        <div className="facesheet-personal">
            <div className="facesheet-personal__info-item">
                <span className="h5">Name: </span>
                <span className="p-regular">{getVerificationResult(verifications.data.nameVerification)}</span>
            </div>
            <div className="facesheet-personal__info-item">
                <span className="h5">Social Security Number: </span>
                <span className="p-regular">{getVerificationResult(verifications.data.ssnVerification)}</span>
            </div>
            <div className="facesheet-personal__info-item">
                <span className="h5">Date Of Birth: </span>
                <span className="p-regular">{getVerificationResult(verifications.data.dateOfBirthVerification)}</span>
            </div>
            <div className="facesheet-personal__info-item">
                <span className="h5">Address: </span>
                <span className="p-regular">{getVerificationResult(verifications.data.addressVerification)}</span>
            </div>
        </div>
    );
};
